import { useEffect, useState } from 'react'

type InfoWindow = google.maps.InfoWindow
type Marker = google.maps.Marker
type MarkerOptions = google.maps.MarkerOptions

interface GoogleMapMarkerProps extends MarkerOptions {
  active?: boolean
  infoWindow: InfoWindow,
  infoWindowContent?: string,
  onClick?: () => void,
  onDomReady?: () => void,
}

const GoogleMapMarker = ({
  active,
  infoWindow,
  infoWindowContent,
  onClick,
  onDomReady,
  ...options
}: GoogleMapMarkerProps) => {
  const [marker, setMarker] = useState<Marker>()
  useEffect(() => {
    if (!marker) {
      setMarker(new google.maps.Marker())
    }
    return () => {
      if (marker) {
        marker.setMap(null)
      }
    }
  }, [marker])
  useEffect(() => {
    if (infoWindow && infoWindowContent && marker) {
      if (active) {
        openInfoWindow()
      }
      marker.addListener('click', openInfoWindow)
    }
  }, [active, infoWindow, infoWindowContent, marker])
  useEffect(() => {
    if (marker) {
      marker.setOptions(options)
    }
  }, [marker, options])

  const openInfoWindow = () => {
    if (infoWindow && infoWindowContent && marker) {
      infoWindow.setContent(infoWindowContent)
      infoWindow.open(options.map, marker)
      if (onClick) {
        onClick()
      }
      if (onDomReady) {
        infoWindow.addListener('domready', onDomReady)
      }
    }
  }
  return null
}
GoogleMapMarker.defaultProps = {
  active: false,
  infoWindow: null,
  infoWindowContent: null,
  onDomReady: null,
}
export default GoogleMapMarker
